module.exports = __webpack_public_path__ + "img/Number=24.e033739b.png";